/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_INVOICE_LIST (state, val) {
    state.invoiceList = val
  },
  UPDATE_INVOICE_LIST (state, val) {
    state.invoiceList.push(...val)
  },
  UPDATE_INVOICE (state, invoice) {        
    const i = state.invoiceList.findIndex((i) => i.InvoiceId === invoice.InvoiceId)
    Object.assign(state.invoiceList[i], invoice)
  },
  SET_PERIOD (state, val) {
    state.period = val
  } 
}
